<template>
    <div class="sub-menu">
        <mag-sub-menu-item :item="item" v-for="item in folderCategories" :key="item.id" />
    </div>
</template>

<script>
import Vue from "vue";
import MagSubMenuItem from "./MagSubMenuItem.vue";
import { Services } from "src/services/Services";

export default Vue.extend({
    components: { MagSubMenuItem },
    data() {
        return {
            isHovering: false,
        };
    },
    asyncComputed: {
        async folderCategories() {
            const folderCategories = await Services.api.mag.getCategories();
            return folderCategories && folderCategories.length > 0
                ? [
                      ...folderCategories.slice(0, 3),
                      {
                          id: "other_folders",
                          title: "Dossiers",
                          children: folderCategories.slice(3),
                      },
                  ]
                : [];
        },
    },
});
</script>

<style lang="sass" scoped>
.sub-menu
    background: #F2F2F2
    display: flex
    align-items: center
    justify-content: stretch
    height: 60px
    width: 100%
    border-top: 1px solid rgba(176,177,166,0.6)
</style>
